// extracted by mini-css-extract-plugin
export default {"summaryCardBody":"home-page_summaryCardBody__H5CH+","summaryRowValue":"home-page_summaryRowValue__iBofo","dashboardStatsArea":"home-page_dashboardStatsArea__G2j1x"};
    if(module.hot) {
      // 1790680669259
      var cssReload = require("/home/garphild.pro/web/drones.garphild.pro/private/nodeapp/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  